import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import {Slider, Pagination} from 'react-slick';
import { ImageLazyLoad } from '../../';
import { formatNumber } from '../../../utils';
import './styles.scss';

const propTypes = {
  snapshotsData: PropTypes.object,
};

const defaultProps = {
  snapshotsData: {},
  slickSettings: {
    infinite: true,
    arrows: false,
    adaptiveHeight: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide:0,
    paginationName: 'top-snapshots-pagination',
    afterChange: function() {
      window.dispatchEvent(new CustomEvent('checkImageLazyload'));
    },
    init: function() {
      window.dispatchEvent(new CustomEvent('checkImageLazyload'));
    },
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
        }
    }, {
        breakpoint: 500,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
        }
    }]
  }
};

class TopSnapshotsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {navigationEnabled: false};
    this.paginationRender = this.paginationRender.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.snapshots.length > 3) {
      this.setState({navigationEnabled: true});
    } else {
      this.setState({navigationEnabled: false});
    }
  }

  componentDidMount() {
    if(this.props.snapshotsData.snapshots && this.props.snapshotsData.snapshots.length > 2) {
      this.setState({navigationEnabled: true});
    } else {
      this.setState({navigationEnabled: false});
    }
  }

  next(){
    if(this.state.navigationEnabled)
      this.topSnapshotsSlider.slickNext();
    document.dispatchEvent(new CustomEvent('resize'));
  }
  previous(){
    if(this.state.navigationEnabled)
      this.topSnapshotsSlider.slickPrev();
    document.dispatchEvent(new CustomEvent('resize'));
  }

  paginationRender(currentPage, totalPages) {
    return (
      <span ref="slideNumber" type="text" className="pagination-numbers">{currentPage} / {totalPages} </span>
    );
  }

  render() {
    const { snapshotsData, slickSettings } = this.props;
    const { navigationEnabled } = this.state;
    const disabled = (navigationEnabled) ? '' : ' disabled';
    const loaderProps = { style: { height: 144 }, dark: true };
    return (
      <div className="member-slider-group top-snapshots-group">
        <div className="row">
          <div className="section-header col-12 bg-fff-80 border-grey">
            <div className="row no-gutters">
              <div className="title-link border-r-grey title-block">Top 10</div>
              <div className="title-block col u-font-foundation-light light-grey">Snapshots from Members</div>
              <div className="title-block col text-right u-font-foundation-light light-grey">Week of { moment(snapshotsData.start_date).format('MM/DD/YYYY') } </div>
              <div className={"title-block border-l-grey pagination-button" + disabled} onClick={this.previous}><i className="icon-ButtonArrowLeft"></i></div>
              <div className={"title-block border-l-grey pagination-button" + disabled} onClick={this.next}><i className="icon-ButtonArrowRight"></i></div>
            </div>
          </div>
        </div>
        <div className="row">
          { snapshotsData.snapshots && snapshotsData.snapshots.length > 0 &&
          <Slider {...slickSettings} ref={c => this.topSnapshotsSlider = c} className='top-snapshots-slider'  paginationRender={this.paginationRender}>
            {_.chunk(snapshotsData.snapshots, 10)[0].map(function(snapshot, index){
              let name = (!_.isEmpty(snapshot.display_name)) ? snapshot.display_name : snapshot.username;
              let avatar = (snapshot.avatar_id) ? `https://explore.org/avatars/${snapshot.avatar_id}/100/100/y/${snapshot.username}.jpg` :
                'https://explore.org/images/icon_avatar_default.png';
              return (
                <a href={snapshot.snapshots_url} target="_blank" key={index} className="top-snapshot-wrap u-font-foundation-roman u-textSize-18">
                  <div className="top-snapshot" >
                    <div className="row no-gutters align-items-center">
                      <div className="number-box">{index + 1}</div>
                      <div className="col pl-10 pr-10">{name}</div>
                      <div className="col text-right pl-10 pr-10 u-font-foundation-light light-grey">{ formatNumber(snapshot.snapshots_count) } Snapshots</div>
                      <div>
                        <img className="small-avatar" src={avatar} />
                      </div>
                    </div>
                    <img className="top-snapshot-img" src={snapshot.full_size_url} />
                  </div>
                </a>
              );
            })}
          </Slider>
          }
        </div>
      </div>
    )
  }
}

TopSnapshotsView.propTypes = propTypes;
TopSnapshotsView.defaultProps = defaultProps;

export default TopSnapshotsView;
